const LOADER_START = 'LOADER_START';
const LOADER_STOP = 'LOADER_STOP';
const SET_COLUMN_PREFERENCES = 'SET_COLUMN_PREFERENCES';
const UPDATE_FILE_MANAGER = 'UPDATE_FILE_MANAGER';

const loaderStart = () => ({
  type: LOADER_START
});

const loaderStop = () => ({
  type: LOADER_STOP
});

const setColumnPreferences = payload => ({
  type: SET_COLUMN_PREFERENCES,
  payload
});

const updateFileManager = payload => ({
  type: UPDATE_FILE_MANAGER,
  payload
});

export default {
  LOADER_START,
  LOADER_STOP,
  SET_COLUMN_PREFERENCES,
  UPDATE_FILE_MANAGER,
  setColumnPreferences,
  loaderStart,
  loaderStop,
  updateFileManager
};
